import { gql } from "@apollo/client";

export const BORRAR_CONEXIONES = gql`
mutation BorrarConexiones($input: [Int!]!) {
  borrarConexiones(input: $input)
}
`;